import { createSlice } from "@reduxjs/toolkit";

// Helper to safely parse JSON values stored in localStorage
const safeParse = (raw) => {
  if (!raw) return null;
  try { return JSON.parse(raw); } catch { return null; }
};

const authSlice = createSlice({
  name: "auth",
  initialState: {
    // Store normalized object (not string) in Redux state
    user: safeParse(localStorage.getItem("user")),
    // Coerce to boolean; treat anything other than literal 'true' as false
    isloggedin: localStorage.getItem("isloggedin") === 'true',
    token: localStorage.getItem("token"),
    refreshToken: localStorage.getItem("refreshToken"),
    isUserInActive: false,
    isDailyLimitReached: false,
    language : 'English'
  },
  reducers: {
    setTokens: (state, action) => {
      if (!action.payload) {
        return; // Silently ignore null/undefined payloads
      }
      const { token, refreshToken } = action.payload;
      
      // Update token if it's provided (even if null/undefined)
      if (action.payload.hasOwnProperty('token')) {
        state.token = token;
        if (token) {
          localStorage.setItem("token", token);
        } else {
          localStorage.removeItem("token");
        }
      }
      
      // Update refreshToken if it's provided and truthy
      if (refreshToken) {
        state.refreshToken = refreshToken;
        localStorage.setItem("refreshToken", refreshToken);
      }
    },
    setUser: (state, action) => {
      const user = action.payload;
      state.user = user;
      localStorage.setItem("user", JSON.stringify(user));
    },
    setLoginStatus: (state, action) => {  
      state.isloggedin = action.payload;
      state.isUserInActive = false;
      state.isDailyLimitReached = false;
      localStorage.setItem("isloggedin", action.payload);
    },
    logOut: (state, action) => {
      state.isloggedin = false;
      state.user = null;
      state.token = null;
      state.refreshToken = null;
      localStorage.removeItem("isloggedin");
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
    },
    userInActive : (state, action) => {
      state.isUserInActive = action.payload;
    },
    dailyLimitReached : (state, action) => {
      state.isDailyLimitReached = action.payload;
    },
    setLanguage : (state, action) => {
      state.language = action.payload;
    },
  },
});

export const { setTokens, setUser, setLoginStatus , logOut, userInActive, dailyLimitReached, setLanguage } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
export const selectIsLoggedIn = (state) => state.auth.isloggedin;
export const selectCurrentToken = (state) => state.auth.token;
export const selectCurrentRefreshToken = (state) => state.auth.refreshToken;
export const selectLanguage = (state) => state.auth.language;
export const selectIsUserInActive = (state) => state.auth.isUserInActive;
export const selectDailyLimitReached = (state) => state.auth.isDailyLimitReached;
